import { makeStyles } from '@material-ui/styles'
import { ErrorMessage } from 'core/components/validatedForm/ErrorMessage'
import Theme from 'core/themes/model'
import Text from 'pf9-ui-components/built/elements/Text'
import React from 'react'
import PhysicalNodesTable from './PhysicalNodesTable'
import SelectableCardWrapper from './SelectableCardWrapper'

const controlPlaneClassOptions = [
  { label: 'Highly available - 3 masters (default)', value: 'high-availability' },
]

/**
 * Cluster Architecture Fields component
 * @param param0 - params, getParamsUpdater, physicalNodeErrors
 * @returns Cluster Architecture Fields component is used for cluster architecture selection for BYO infrastructure
 */
export default function ClusterArchitectureFieldsBYO({
  params,
  getParamsUpdater,
  physicalNodeErrors,
  setError,
}) {
  const classes = useStyles()
  return (
    <>
      {/* Select OpenStack Infrastructure */}
      <div className={classes.clusterArchitectureFields}>
        <Text variant="body2">Select the physical nodes for cluster.</Text>
        <PhysicalNodesTable
          selectedNodes={params?.physicalNodes}
          getParamsUpdater={getParamsUpdater}
          setError={setError}
        />
        {physicalNodeErrors && (
          <ErrorMessage data-testid="physical-node-error">
            {physicalNodeErrors.message}
          </ErrorMessage>
        )}
        <div className={classes.controlPlaneOptions}>
          <Text variant="body2">Select the type of control plane.</Text>
          <div className={classes.SelectableCardWrappers}>
            <SelectableCardWrapper
              id="managed"
              onClick={getParamsUpdater('controlPlaneType')}
              active={params?.controlPlaneType === 'managed'}
              title="Managed Control Plane"
              description="On PCD"
            />
            <SelectableCardWrapper
              id="custom"
              // Set the onClick to noop till option is supported
              onClick={() => {}}
              // onClick={() => getParamsUpdater('controlPlaneType')}
              active={params?.controlPlaneType === 'custom'}
              title="Custom Control Plane"
              description="Advanced"
              comingSoon
            />
          </div>
        </div>
      </div>
    </>
  )
}

const useStyles = makeStyles<Theme>((theme) => ({
  clusterArchitectureFields: {
    display: 'grid',
    gridGap: theme.spacing(2),
  },
  controlPlaneOptions: {
    display: 'grid',
    margin: theme.spacing(2, 0),
    gridGap: theme.spacing(2),
  },
  SelectableCardWrappers: {
    display: 'grid',
    gridTemplateColumns: 'max-content max-content',
    gridGap: theme.spacing(2),
  },
}))
